import { MediaQueryWrapper, TranslationsContext } from '@telia-common-components/shared';
import React from 'react';
import { Grid, GridColumn, Icon, Separator, Skeleton, SkeletonItem, useTheme } from 'telia-front-react';
import { FetchStatus } from '../../../../util/FetchStatus';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { ExtraCard } from './ExtraCard';
const ExtraInformationAndCards = (props) => {
    const { translate } = React.useContext(TranslationsContext);
    const { showRequestForm, addressSelected, isLoading } = props;
    const { media } = useTheme();
    const { internetCalculatorExtraCardsState, secureNetCalculatorExtraCardsState, isSecureNet } = useInternetCalculator();
    const areExtraCardsFetching = () => [FetchStatus.UNINITIALIZED, FetchStatus.FETCHING].includes((isSecureNet ? secureNetCalculatorExtraCardsState : internetCalculatorExtraCardsState).status);
    const getOfferCardForCurrentScreenSize = (offerSuffix) => (React.createElement(MediaQueryWrapper, { minWidth: media.width.md.min, matchingContent: React.createElement(ExtraCard, { slug: `${offerSuffix}-desktop` }), unmatchingContent: React.createElement(ExtraCard, { slug: `${offerSuffix}-mobile` }) }));
    const renderExtraCards = () => {
        if (isSecureNet) {
            return renderSecureNetExtraCard();
        }
        if (addressSelected && showRequestForm) {
            return (React.createElement(Grid, null,
                React.createElement(GridColumn, { width: ['xs-12', 'md-6'] }, getOfferCardForCurrentScreenSize('partner-internet-request')),
                React.createElement(GridColumn, { width: ['xs-12', 'md-6'] },
                    React.createElement(ExtraCard, { slug: "telia-one-offer-card-mobile" }))));
        }
        return getOfferCardForCurrentScreenSize('telia-one-offer-card');
    };
    const renderSecureNetExtraCard = () => {
        return (React.createElement(Grid, null,
            React.createElement(GridColumn, { width: ['xs-12'] }, getOfferCardForCurrentScreenSize('business-class-offer-card'))));
    };
    const renderSecureNetExtraCardSkeleton = () => {
        return (React.createElement(Skeleton, { label: translate('skeleton.loading') },
            React.createElement(Grid, null,
                React.createElement(GridColumn, { width: ['xs-12', 'md-6'] }, getSkeletonItemForCurrentScreenSize('353px', '242px')))));
    };
    const getSkeletonItemForCurrentScreenSize = (desktopHeight, mobileHeight) => (React.createElement(MediaQueryWrapper, { minWidth: media.width.md.min, matchingContent: React.createElement(SkeletonItem, { height: desktopHeight }), unmatchingContent: React.createElement(SkeletonItem, { height: mobileHeight }) }));
    const renderExtraCardsSkeleton = () => {
        if (isSecureNet) {
            return renderSecureNetExtraCardSkeleton();
        }
        if (addressSelected && showRequestForm) {
            return (React.createElement(Skeleton, { label: translate('skeleton.loading') },
                React.createElement(Grid, null,
                    React.createElement(GridColumn, { width: ['xs-12', 'md-6'] }, getSkeletonItemForCurrentScreenSize('353px', '242px')),
                    React.createElement(GridColumn, { width: ['xs-12', 'md-6'] }, getSkeletonItemForCurrentScreenSize('353px', '358px')))));
        }
        return React.createElement(Skeleton, { label: translate('skeleton.loading') }, getSkeletonItemForCurrentScreenSize('154px', '342px'));
    };
    const renderInformationSection = () => {
        const informationContent = React.createElement(React.Fragment, null, translate('internetCalculator.extraInfo.content'));
        return (React.createElement(MediaQueryWrapper, { minWidth: media.width.md.min, matchingContent: React.createElement(Grid, { noWrap: true, horizontalGutter: "small" },
                React.createElement(GridColumn, { width: ['min'] },
                    React.createElement(Icon, { modifiers: "#info-round", size: "xs" })),
                React.createElement(GridColumn, { width: ['xs-10'], align: ['middle-xs'] }, informationContent)), unmatchingContent: informationContent }));
    };
    const renderInformationSectionSkeleton = () => {
        return (React.createElement(Skeleton, { label: translate('skeleton.loading') },
            React.createElement(MediaQueryWrapper, { minWidth: media.width.sm.min, matchingContent: React.createElement(SkeletonItem, { height: "90px" }), unmatchingContent: React.createElement(SkeletonItem, { height: "110px" }) })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Separator, { spacing: "small", color: "invisible" }),
        isLoading ? renderInformationSectionSkeleton() : renderInformationSection(),
        React.createElement(Separator, { spacing: "small", color: "invisible" }),
        areExtraCardsFetching() ? renderExtraCardsSkeleton() : renderExtraCards()));
};
export default ExtraInformationAndCards;
